<template>
<panel>
  <p slot="header">
    {{ item.name }}
  </p>
  <p slot="actions">
    <ui-button type="flat" color="primary" @click="cancel">Anuluj</ui-button>
  </p>
  <accounts-form :item="item" v-if="item.id"></accounts-form>
</panel>

</template>
<script>
import Accounts from './../../services/Accounts'
import Loading from './../../mixins/Loading'
import Notify from './../../mixins/Notify'

export default {
  mixins: [Loading, Notify],
  data () {
    return {
      item: Accounts.getBaseItem()
    }
  },
  mounted () {
    const id = this.$route.params.id
    this.getItem(id)
  },
  methods: {
    cancel () {
      this.$router.push({name: 'admin.accounts.dashboard', params: {id: this.item.id}})
    },
    getItem (id) {
      this.setLoading(true)
      Accounts.get(id).then((res) => {
        this.item = res.data.item
        this.setLoading(false)
      })
    }
  }
}

</script>


// WEBPACK FOOTER //
// Edit.vue?659529d3